import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { functionpermission, saveMasterServiceActivityBO, serviceactivityBO, ServiceTaxBO } from '../manage-service.modal';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ServiceActivityDataservice } from '../service-activity/service-activitydateservice';
import { ManageService } from '../manage-service.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalComponent } from 'src/app/global/global.component';
import { ServiceTaxDataservice } from './service-taxdataservice';
import { AgencyService } from '../../agency/agency.service';
import { promise } from 'protractor';
import { error } from 'console';

@Component({
  selector: 'app-service-tax',
  templateUrl: './service-tax.component.html',
  styleUrls: ['./service-tax.component.scss']
})



export class ServiceTaxComponent implements OnInit {
  groupId: any;
  statusList:any=[];
  statusListId:any;
  ServicestatusList:any=[];
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridServiceTaxGroup') public gridServiceTaxGroup: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  saveserviceactivitymap: saveMasterServiceActivityBO = new saveMasterServiceActivityBO();
  ServiceGroupList: any = [];
  ServiceCodeList: any = [];
  MSFilterBo: serviceactivityBO = new serviceactivityBO();
  ModalType: string = "new";
  ServiceActivityArray: any = [];
  TaxNamesList: any = [];
  constructor(public DateService: ServiceTaxDataservice,
    public Msservice: ManageService,
     public httpService: AgencyService,
    public global: GlobalComponent, public toasterservice: ToastrService) {

    this.GridList = DateService;
  }
  fp: functionpermission = new functionpermission()
  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    // this.MSFilterBo.field="serviceGroupName";
    // this.MSFilterBo.orderColumn="serviceGroupName";
    this.GetServiceGroupDropdown();
    this.getpermission();
    this.getStatusDropDown();

  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Manage Services");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.Msservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }
  // ................................................dataChangeServiceActivity..............................................
  public dataChangeServiceActivity(SG): void {
    let val = (SG.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((SG.sorted || []).length) {
        this.MSFilterBo.orderColumn = SG.sorted[0].name;
        this.MSFilterBo.orderType = SG.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && SG.action.action != "clearFilter") {
      this.MSFilterBo.value = SG.action.currentFilterObject.value;
      this.MSFilterBo.field = SG.action.currentFilterObject.field;
      this.MSFilterBo.matchCase = SG.action.currentFilterObject.matchCase;
      this.MSFilterBo.operator = SG.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && SG.action.action == "clearFilter") {
        this.MSFilterBo.field = "serviceGroupName";
        this.MSFilterBo.matchCase = false;
        this.MSFilterBo.operator = "contains";
        this.MSFilterBo.value = "";
        this.MSFilterBo.type = "string";
      }
    }
    this.getServiceActivityFilter();
    if (val == "paging" && SG.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }
  //.........................................onActionServiceActivity.....................................................
  public onActionServiceActivity(SG) {
    this.MSFilterBo.currentpageno = this.gridServiceTaxGroup.pageSettings.currentPage;
    this.MSFilterBo.pageitem = this.gridServiceTaxGroup.pageSettings.pageSize;
    if (SG.name == "actionBegin" && SG.requestType == "filterbeforeopen") {
      this.MSFilterBo.type = SG.columnType
    }
  }
  // ............................................................................................................................//


  CreateupdateServiceActivity(type: string) {
    if (type == 'new') {
      this.ModalType = 'new';
      this.ServiceTaxArray = [];
      this.selectedTaxes = [];
      this.availableActivities = [];
      this.groupId=this.ServiceGroupList?.filter(e=>e.Value=="Self-Direction Support Activities")[0].Key;
      this.getTaxList();
      this.GetServiceCodeDropdown(this.groupId);
      this.valuchangesServiceActivity();
        this.ServiceTaxArray.statusLid = this.statusList?.find(
          (e) => e.lovName?.toUpperCase()=="ACTIVE"
        )?.id;
    } else {
      this.getTaxList();
      this.valuchangesServiceActivity();
      this.ModalType = 'edit';
    }

  }



  //...........................................getDetails..........................................//
  ServiceTaxArray: any = [];
  getDetails(data) {
    this.serviceTaxId=data.id;
    this.groupId = this.ServiceGroupList?.filter(ele => ele.Value == data.serviceGroupName)[0].Key
    this.GetServiceCodeDropdown(this.groupId);
    this.ServiceTaxArray.serviceId = data.serviceId;
       this.ServiceTaxArray.statusLid = data.statusLid;
      this.getServiceSelectedTaxList(this.ServiceTaxArray.serviceId);


  }
  //............................................Refresh...................................................
  Refresh() {
    this.saveserviceactivitymap = new saveMasterServiceActivityBO();
    this.statusListId=this.ServicestatusList?.find((e)=>e.lovName?.toUpperCase()=="ACTIVE")?.id;

    this.getServiceActivityFilter();

  }

  //.........................................getServiceActivityFilter.............................................
  getServiceActivityFilter() {
        this.MSFilterBo.statusLid=this.statusListId;
    this.DateService.execute(this.MSFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridServiceTaxGroup.height = '500';
      }
      else {
        this.gridServiceTaxGroup.height = 'auto';
      }
    })
  }
  ServiceTaxBO: ServiceTaxBO[] = [];
  public serviceTaxId='';

  // ..............................................................................................................................//
  SaveOrUpdateServiceTax(ServiceTaxArray) {
    console.log(ServiceTaxArray);
    this.ServiceTaxBO=[];
    if(this.ModalType !='edit'){
      this.serviceTaxId="00000000-0000-0000-0000-000000000000"
    }
    else{
      this.serviceTaxId=this.serviceTaxId;
    }
    this.ServiceTaxArray.taxId?.forEach((element, index) => {
      const obj = {
        id: this.serviceTaxId,
        serviceId: ServiceTaxArray.serviceId,
        masterServiceName: this.Service?.filter(ele => ele.Key == ServiceTaxArray.serviceId)[0].Value,
        taxId: element,
        taxName: this.TaxNamesList?.filter(ele => ele.taxId == element)[0].taxName,
        serviceGroupName: this.ServiceGroupList?.filter(ele => ele.Key == this.groupId)[0].Value,
        statusLid:this.ServiceTaxArray.statusLid,

      }
      this.ServiceTaxBO?.push(obj)
    });

    console.log(this.ServiceTaxBO, "ServiceTaxBO")
    this.Msservice.saveServicesTax(this.ServiceTaxBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        this.valuchangesServiceActivity();

        if (this.ModalType == 'new') {
          this.toasterservice.success('ServiceTax saved successfully', 'ServiceTax Saved');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
          document.getElementById('openServiceTaxModal').click();
        }
        else {
          this.toasterservice.success('ServiceTax updated successfully', 'ServiceTax Updated');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
          document.getElementById('openServiceTaxModal').click();
        }
        this.getServiceActivityFilter();
      }



    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }











  //.........................................SaveOrUpdateServiceActivity .............................................
  // SaveOrUpdateServiceActivity (serviceId) {
  //    let savepayload: saveMasterServiceActivityBO = JSON.parse(JSON.stringify(this.saveserviceactivitymap));
  //    savepayload.id = this.saveserviceactivitymap.id;



  //    this.Msservice.saveServicesActivity(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //        if (this.saveserviceactivitymap.id == '00000000-0000-0000-0000-000000000000') {
  //          this.toasterservice.success('Service Group saved successfully!');
  //         setTimeout(() => {
  //           this.toasterservice.clear();
  //         }, 8000);

  //        }
  //        else if (this.saveserviceactivitymap.id != '00000000-0000-0000-0000-000000000000') {
  //         this.toasterservice.success('Service Group updated successfully!');
  //          setTimeout(() => {
  //           this.toasterservice.clear();
  //         }, 8000);
  //       }
  //       document.getElementById('openServiceActivityModal').click();
  //        this.saveserviceactivitymap = new saveMasterServiceActivityBO();
  //       this.getServiceActivityFilter();
  //   }, (err: any) => {
  //     if (err) {
  //       this.toasterservice.error(err, 'Error'), 8000;
  //     }
  //   })
  // }

  showServiceActivityColumns() {
    this.gridServiceTaxGroup.columnChooserModule.openColumnChooser(200, 50);
  }
  //..........................................DeleteServiceActivity ...........................................................
  DeleteServiceActivity() {
    let params = new URLSearchParams();
    params.append("Id", this.saveserviceactivitymap.id);
    this.Msservice.DeleteServiceActivity(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterservice.success('Service Activitymapping deleted successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('closeSAModal').click();
      this.getServiceActivityFilter();
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  clearServiceActivity() {
    this.saveserviceactivitymap = new saveMasterServiceActivityBO();
    this.ServiceTaxArray.serviceId = null
    this.availableActivities = []
    this.selectedTaxes = []
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  //..........................................GetServiceGroupDropdown...........................................................
  //  GetServiceGroupDropdown() {
  //   this.Msservice.GetServiceGroupDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.ServiceGroupList = data; 
  //     console.log(this.ServiceGroupList)
  //   }, (err: any) => {
  //     if (err) {
  //       this.toasterservice.error(err, 'Error'), 8000;
  //     }
  //   });
  // }
  // .....................................................................................................................//

  GetServiceGroupDropdown() {
    this.Msservice.GetServiceGroupDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ServiceGroupList = data;
      this.ServiceGroupList.forEach(element => {
        element.label = element.name;
        element.value = element.id;
      })
    });
  }




  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  selectedServiceID: string;
  availableActivities: any = [];
  selectedTaxes: any = [];



  getServiceSelectedTaxList(serviceGroupId) {


    let params = new URLSearchParams();
    params.append("serviceId", serviceGroupId);
    this.Msservice.getServiceSelectedTaxList(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
     this.ServiceTaxArray.taxId=data?.map(element=>element.Key)
    });
  }

  //..........................................GetServiceCodeDropdown...........................................................
  Service: any = []
  GetServiceCodeDropdown(serviceGroupId) {
    if(serviceGroupId){
      let params = new URLSearchParams();
      params.append("serviceGroupId", serviceGroupId);
      this.Msservice.GetServiceCodeDropdown(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.Service = data;
      }, (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      });
    }
    else{
      this.ServiceTaxArray.serviceId=null
    }
  }

  // ..................................................................Drag and Drop..................................
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }
  isViewServiceActivityMapping = false;
  checkpopServiceActivity() {
    this.isViewServiceActivityMapping = true;
  }


  valuchangesServiceActivity() {
    this.isViewServiceActivityMapping = false;
  }


  getTaxList() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();

      params.append("agencyId", this.global.globalAgencyId)
      this.Msservice.getAllTaxNamesList(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.TaxNamesList = data;
        }

      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }
  pr1:Promise<any>;
  getStatusDropDown() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
     this.pr1= new Promise((resolve,reject)=>{
     this.httpService
      .getLovStatus(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.statusList = data;       
        resolve(data);
        this.getstatutaxlist()
      },
     (err: any) => {
       
            this.toasterservice.error(err, "error");
            reject(err)
            setTimeout(() => {
              this.toasterservice.clear();
            }, 8000);});
  })
  return this.pr1;
  }
   async getstatutaxlist(){
    this.ServicestatusList=[];
    await  this.pr1.then((data)=>{this.ServicestatusList=JSON.parse(JSON.stringify(data))});
     let values = {
          id: null,

          lovName: "All",

          lovCode: "ALL",

          lovValue: "ALL",
        };
    this.ServicestatusList.push(values);
    this.statusListId=this.ServicestatusList?.find((e)=>e.lovName?.toUpperCase()=="ACTIVE")?.id;
    this.getServiceActivityFilter();   
  }

}